import React from "react";
import { Checkbox } from "office-ui-fabric-react";
import Theme from "../../styles/theme.js";

// Standard table wrapper
export const StandardTable = ({ children, style = {} }) => (
  <div style={{ margin: Theme.layout.contentPadding }}>
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: Theme.layout.contentPadding,
        ...style,
      }}
    >
      {children}
    </table>
  </div>
);

// Standard table header
export const StandardTableHeader = ({ columns }) => (
  <thead>
    <tr style={{ backgroundColor: Theme.colors.background }}>
      {columns.map((column, index) => (
        <th
          key={index}
          style={{
            border: `1px solid ${Theme.colors.border}`,
            padding: "8px",
            textAlign: "left",
            fontWeight: Theme.typography.fontWeight.medium,
          }}
        >
          {column}
        </th>
      ))}
    </tr>
  </thead>
);

// Standard table body
export const StandardTableBody = ({ children }) => <tbody>{children}</tbody>;

// Standard table row
export const StandardTableRow = ({ children, index }) => (
  <tr
    style={{
      backgroundColor:
        index % 2 === 0 ? Theme.colors.background : Theme.colors.cardBackground,
    }}
  >
    {children}
  </tr>
);

// Standard table cell
export const StandardTableCell = ({ children, style = {} }) => (
  <td
    style={{
      border: `1px solid ${Theme.colors.border}`,
      padding: "8px",
      ...style,
    }}
  >
    {children}
  </td>
);

// Feature flags table specifically for the FeatureFlags screen
export const FeatureFlagsTable = ({
  featureFlags,
  onToggleFlag,
  showTenantColumns = false,
  onDeleteFlag,
  isAdmin = false,
}) => {
  if (!featureFlags || featureFlags.length === 0) {
    return null;
  }

  const columns = showTenantColumns
    ? ["Feature Name", "Enabled", "Tenant ID", "SPHost", "Team ID", "Delete"]
    : ["Feature Flag", "Enabled", "Delete"];

  return (
    <StandardTable>
      <StandardTableHeader columns={columns} />
      <StandardTableBody>
        {featureFlags.map((flag, index) => (
          <StandardTableRow key={index} index={index}>
            <StandardTableCell>
              {showTenantColumns ? flag.featureName : flag.name}
            </StandardTableCell>
            <StandardTableCell>
              <Checkbox
                checked={showTenantColumns ? flag.enabled : flag.enabled}
                onChange={(event, newValue) => onToggleFlag(flag, newValue)}
              />
            </StandardTableCell>
            {showTenantColumns && (
              <>
                <StandardTableCell>{flag.tenantId}</StandardTableCell>
                <StandardTableCell>{flag.spHost}</StandardTableCell>
                <StandardTableCell>{flag.teamId}</StandardTableCell>
                <StandardTableCell>
                  <i
                    className="fa fa-trash"
                    style={{
                      fontSize: "32px",
                      cursor: flag.enabled ? "not-allowed" : "pointer",
                      opacity: flag.enabled ? 0.3 : 1,
                      color: flag.enabled ? "grey" : Theme.colors.error,
                    }}
                    onClick={() => {
                      if (!flag.enabled) {
                        onDeleteFlag(flag);
                      }
                    }}
                  />
                </StandardTableCell>
              </>
            )}
            {!showTenantColumns &&
              (() => {
                const isGlobalFlag = !flag.name.includes("__");
                const deleteDisabled =
                  flag.enabled || (isGlobalFlag && !isAdmin);
                return (
                  <StandardTableCell>
                    <i
                      className="fa fa-trash"
                      style={{
                        fontSize: "32px",
                        cursor: deleteDisabled ? "not-allowed" : "pointer",
                        opacity: deleteDisabled ? 0.3 : 1,
                        color: deleteDisabled ? "grey" : Theme.colors.error,
                      }}
                      title={
                        isGlobalFlag && !isAdmin
                          ? "Admin permissions required to delete global flags"
                          : undefined
                      }
                      onClick={() => {
                        if (!deleteDisabled) {
                          onDeleteFlag(flag);
                        }
                      }}
                    />
                  </StandardTableCell>
                );
              })()}
          </StandardTableRow>
        ))}
      </StandardTableBody>
    </StandardTable>
  );
};
